<template>
    <div class="dashboard">
        <div class="row">
            <timeline :showGalleries="true"></timeline>
            {{weekChange}}
        </div>
        <div class="row">
            <div class="col-xs-6 col-md-6">
                <div class="panel intro-video-wrapper">
                    <div class="panel-heading">
                        <h2 v-if="localStorage.terms=='858356'">Intro Video</h2>
                        <h2 v-if="localStorage.terms!='858356' && noIntroVideo===false">Week {{currentWeek + 1}} Intro Video<i class="clippie fa fa-info-circle" v-tooltip="'Your weekly introduction video from your supervisor and more!'"></i></h2></div>
                    <div class="panel-body"> 
                        <img v-if="noIntroVideo===true" src="../assets/img/video-placeholder.jpg" class="video-placeholder">
  
                        <poly-video
                            :class="{ 'hide-annotations': showAnnotations === false }"
                            :sources="[ introVideoUrl ]"
                            v-else>
                        </poly-video>
                    </div>

                </div>
                <next-live-session></next-live-session>
            </div>

            <div v-if="noTerm" class="col-xs-6 col-md-6"><img class="mock-assignments" src="../assets/img/courses-placeholder.jpg"></div>
            <div v-if="courses && assignmentsLoaded" class="col-xs-6 col-md-6">
                <div class="panel course-widget-wrapper">
                    <div class="panel-heading">
                        <h2>My Courses<i class="clippie fa fa-info-circle" v-tooltip="'Your courses including direct links to this week\'s videos, assignments and exercises.'"></i></h2>

                        <div v-if="hasCourseSets && currentTerm.courseSets && currentTerm.courseSets.length > 0" class="course-set-switcher">
                            <ul>
                                <li v-for="set in currentTerm.courseSets"><span
                                        @click.prevent="selectCourseSet(set.id)"
                                        :class="{'selected': currentTerm.selectedCourseSet == set.id}"
                                        href="#">
                                        {{set.name}}</span></li>
                            </ul>
                        </div>

                    </div>
                    <div class="panel-body">
                        <ul v-if="currentTerm && new Date(currentTerm.startDate) <= new Date()" class="list-group courses">

                            <li
                                class="list-group-item row course-list"
                                v-if="course && course.associated  && course.associated.latestVideo && course.associated.latestVideo.length > 0"
                                v-show="
                                !course.associated.courseSets
                                || !currentTerm.selectedCourseSet
                                || course.associated.courseSets.length === 0
                                || course.associated.courseSets.includes(currentTerm.selectedCourseSet)"
                                v-for="course in courses">
                                {{selectedCourseSet}}
                                <div class="clearfix video"
                                    v-if="!video.lastWeekAvailable || (video.lastWeekAvailable && video.lastWeekAvailable >= (currentWeek +1))"
                                    v-for="video in course.associated.latestVideo">
                                    <div class="col-xs-4 video-thumb-wrapper"  :class="{'faded': video.week !== currentWeek + 1}">
                                        <div class="video-thumbnail">

                                            <router-link
                                                :to="{ name: 'videoPlayer',
                                                params: { courseId: course.associated.courseId, instanceId: course.id, videoId: video.id },
                                                query: { term: course.term, week: video.week} }">
                                                <img v-if="course.associated.image" class="course-image" :src="course.associated.image">
                                                <img v-else class="course-image" src="../assets/img/ttto-thumbnail.png">
                                                <img class="play-button" src="../assets/img/play-button.png">
                                            </router-link>



                                        </div>
                                    </div>
                                    <div class="col-xs-8 course-details"  :class="{'faded': video.week !== currentWeek + 1}">
                                        <div class="clearfix">

                                            <h3 class="course-name">

                                                <router-link
                                                    :to="{name: 'course',
                                                    params: {
                                                    termId: course.term,
                                                    courseId: course.associated.courseId,
                                                    instanceId: course.id
                                                    }
                                                    }"
                                                >
                                                    {{course.associated.name}}

                                                </router-link>

                                            </h3>
                                            <router-link
                                            v-if="course.assignments
                                                && course.assignments[0]
                                                && course.associated.latestVideo
                                                && assignmentThisWeek(course.assignments, video.week)"
                                                :to="{
                                                name: 'videoPlayer',
                                                params: {
                                                courseId: course.associated.courseId, instanceId: course.id, videoId: video.id }, query: {term: course.term, week: video.week, tab: 'assignment'} }"
                                            >
                                                <img
                                                    v-if="!assignmentThisWeek(course.assignments, video.week).submission"
                                                    class="icon"
                                                    src="../assets/img/assignment-icon.png"
                                                >
                                                <img
                                                    v-else
                                                    class="icon"
                                                    src="../assets/img/assignment-icon-grey.png"
                                                >
                                            </router-link>

                                            <router-link

                                                v-if="video.exercise"
                                                :to="{
                                                name: 'videoPlayer',
                                                params: {
                                                courseId: course.associated.courseId,
                                                instanceId: course.id,
                                                videoId: video.id
                                                },
                                                query: {
                                                term: course.term, week: video.week, tab: 'exercise'
                                                }
                                                }"
                                            >
                                                <img
                                                    v-if="video.exercise && !video.exercise.exercise_hand_ins.length > 0"
                                                    class="icon"
                                                    src="../assets/img/exercise-icon.png"
                                                >
                                                <img
                                                    v-else
                                                    class="icon"
                                                    src="../assets/img/exercise-icon-grey.png"
                                                >
                                            </router-link>

                                            <div class="video-progress col-xs-12 nopad">
                                                <p>Week {{video.week}}:
                                                    <span class="percent-watched">
                                                        {{calculateProgress(video.progression, video.video_chapters)}}% Watched</span></p>

                                                <div class="ttto-progress-wrapper">
                                                    <div class="ttto-progress" v-bind:style="{'width': calculateProgress(video.progression, video.video_chapters) + '%'}"></div>
                                                </div>
                                            </div>


                                        </div>

                                    </div>


                                </div>
                                <div class="no-video" v-if="course.associated.latestVideo[0].lastWeekAvailable && course.associated.latestVideo[0].lastWeekAvailable < (currentWeek + 1)">
                                    <div class="col-xs-4">
                                        No video this week
                                    </div>
                                    <div class="col-xs-8">

                                        <router-link
                                            :to="{name: 'course',
                                            params: {
                                            termId: course.term,
                                            courseId: course.associated.courseId,
                                            instanceId: course.id
                                            }
                                            }"
                                        >
                                            {{course.associated.name}}
                                        </router-link>

                                    </div>
                                </div>
                            </li>

                            <li
                                v-else
                                v-show="
                                !course.associated.courseSets
                                || !currentTerm.selectedCourseSet
                                || course.associated.courseSets.length === 0
                                || course.associated.courseSets.includes(currentTerm.selectedCourseSet)"
                                class="no-video list-group-item row course-list">
                                <div class="col-xs-4">
                                    No video this week
                                </div>
                                <div class="col-xs-8">

                                    <router-link
                                        :to="{name: 'course',
                                        params: {
                                        termId: course.term,
                                        courseId: course.associated.courseId,
                                        instanceId: course.id
                                        }
                                        }"
                                    >
                                        {{course.associated.name}}
                                    </router-link>

                                </div>
                            </li>
                        </ul>
                        <img v-else src="../assets/img/courses-placeholder.jpg">
                    </div>
                </div>

            </div>

        </div>


        <div class="row" v-if="currentTerm">
            <div class="col-xs-12">
                <div class="panel">
                    <div class="panel-heading assignments">
                        <h2><img src="../assets/img/assignment-icon.png">Assignments<i class="clippie fa fa-info-circle" v-tooltip="'A sortable assignment table including due dates, marks and recorded feedback.'"></i></h2>
                        <div v-if="hasCourseSets && currentTerm.courseSets && currentTerm.courseSets.length > 0" class="course-set-switcher">
                            <ul>
                                <li v-for="set in currentTerm.courseSets">
                                    <span
                                        @click.prevent="selectCourseSet(set.id)"
                                        :class="{'selected': currentTerm.selectedCourseSet == set.id}"
                                        href="#">

                                        {{set.name}}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="panel-body" v-if="noTerm">
                        <img class="mock-assignments" src="../assets/img/assignments-placeholder.jpg">
                    </div>
                    <div class="panel-body" v-else>
                        <div class="assignments"
                            v-if="assignmentsLoaded === true
                            && courses
                            && courses.length > 0
                            && currentTerm && new Date(currentTerm.startDate) <= new Date()"

                        >

                            <assignments-table :currentWeek="currentWeek"></assignments-table>

                        </div>


                    </div>
                </div>
            </div>

        </div>
        <div class="row col-xs-12">
            <latest-posts></latest-posts>
        </div>
        <div class="overlay" v-if="showOverlay">
            <div class="content">
                Thank you for choosing your path for next term.<br>
                If you have any questions, please create an admissions ticket.<br>
            </div>
        </div>

    </div>


</template>


<script>
    import students from '../services/students';
    import introVideos from '../services/intro-videos';
    import oauth from '../services/oauth';
    import terms from '../services/terms';
    import courses from '../services/courses';
    import assignments from '../services/assignments';
    import submissions from '../services/submissions';
    import aws from '../services/aws';

    import moment from 'moment';
    import toastr from 'toastr';
    import router from '../router';
    import assignmentsTable from './reusable/assignments-table/AssignmentsTable.vue';

    import timeline from './widgets/Timeline.vue';
    import NextLiveSession from './widgets/NextLiveSession.vue';
    import LatestPosts from './widgets/LatestPosts.vue';
    import PolyVideo from './reusable/poly-video';


    export default {

        data() {
            return {
                noIntroVideo: false,
                selectedCourse: null,
                showTerms: false,
                assignmentsLoaded:false,
                currentWeek:null,
                showOverlay: false,
                noTerm: false,
                introVideoUrl: null,
                showXmasVideo: false,
            }
        },
        components: {
            timeline,
            PolyVideo,
            LatestPosts,
            'assignments-table': assignmentsTable,
            'next-live-session': NextLiveSession
        },
        mounted() {
            var self = this;
            // this.getTerms();
            if (localStorage.terms == 'null') {
                this.noTerm = true;
            }

            const challengeTermIds = ['583272', '862768', '737438'];

            const realTerms = localStorage.terms.split(',').filter(t => !challengeTermIds.includes(t));

            if (!realTerms.length) {
                this.noTerm = true;
            }           

            const portalSettings = this.$store.getters.settings;
            
            if (portalSettings) {
                const xmasVideo = portalSettings.find(s => s.name === 'xmasIntroVideo');

                if (xmasVideo.value === true) {
                    this.showXmasVideo = true;
                }
            }


            this.currentWeek = this.$store.getters.currentWeek;
            this.showOverlay = this.$route.query.overlay;

            if (this.showOverlay) {
                setTimeout(function() {
                    $('.overlay').fadeOut(function() {
                        self.showOverlay = false;
                    });
                },10000);
            }

            if (localStorage.terms === 'null') {
                if (this.showXmasVideo === true) {
                    this.introVideoUrl = 'https://s3-us-west-2.amazonaws.com/ttto-intro-videos/fee9c950-1a19-406f-b09a-daeedbd6163c.mp4';
                    this.noIntroVideo = false;                    
                } else {
                    this.introVideoUrl = 'https://s3-us-west-2.amazonaws.com/ttto-intro-videos/TTO_00_Director_Intros_01_web2.mp4';
                    this.$forceUpdate();
                }

            }

            if (localStorage.terms == '858356') {
                if (this.showXmasVideo === true) {
                    this.introVideoUrl = 'https://s3-us-west-2.amazonaws.com/ttto-intro-videos/fee9c950-1a19-406f-b09a-daeedbd6163c.mp4';
                } else {
                    this.introVideoUrl = 'https://s3-us-west-2.amazonaws.com/ttto-intro-videos/TTO_00_Director_Intros_01_web2.mp4';
                }
                // this.getCourses(1);
                self.noIntroVideo = false;
                this.$forceUpdate();
            } else {
                if (!this.currentTerm) {
                    let check = window.setInterval(function() {

                        if (self.$store.getters.currentTerm) {
                            self.getCourses(self.currentWeek);
                            window.clearInterval(check);
                        }
                    },500)

                }
            }

            this.weekLimit = this.currentWeek; // don't let student go past this week

            function getQueryVariable(variable) {
                var query = window.location.search.substring(1);
                var vars = query.split('&');
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split('=');
                    if (decodeURIComponent(pair[0]) == variable) {
                        return decodeURIComponent(pair[1]);
                    }
                }
                console.log('Query variable %s not found', variable);
            }

            if (window.location.href.indexOf('redirect_uri') > -1) {
                this.$route.query.client_id = getQueryVariable('client_id');
                this.$route.query.redirect_uri = getQueryVariable('redirect_uri');
                this.authorizeVersapay();
            }
            if (this.$route.query.redirect_uri) {
                this.authorizeVersapay();
            }

        },
        watch: {
            '$store.getters.settings'(portalSettings) {
                const xmasVideo = portalSettings.find(s => s.name === 'xmasIntroVideo');

                if (xmasVideo.value === true) {
                    this.showXmasVideo = true;
                }
            },
            '$store.getters.currentTerm'(term) {
                if (this.currentWeek) {
                    this.getCourses(this.currentWeek);
                    this.getIntroVideo();
                    this.$forceUpdate();
                }

            },
            currentWeek(week)  {
                if (this.$store.getters.currentTerm) {
                    this.getCourses(week);
                    this.getIntroVideo();
                }
            }
        },
        methods: {
            selectCourseSet(id) {
                var self = this;
                this.$store.dispatch('update', {type: 'currentTerm', fields: {selectedCourseSet: id}});
                this.$store.getters.terms.forEach(function(term, index) {

                    if (term.id == self.currentTerm.id) {
                        term.selectedCourseSet = id;
                        self.$store.dispatch('replace', {type: 'terms', data: {object: term, index: index}})
                    }
                });

                if (!localStorage.selectedCourseSets || localStorage.selectedCourseSets === 'undefined') { localStorage.setItem('selectedCourseSets','{}')};

                let selected = JSON.parse(localStorage.selectedCourseSets);
                selected[self.currentTerm.id] = id;
                localStorage.setItem('selectedCourseSets', JSON.stringify(selected));
            },
            authorizeVersapay() {
                var redirect_uri = this.$route.query.redirect_uri || 'https://secure.versapay.com/auth/thinktank/callback';
                var data = {
                    client_id: this.$route.query.client_id || '66383dea-67f9-447a-af69-4bf93100c6ce',
                    redirect_uri: redirect_uri,
                    user: localStorage.account_id
                }
                oauth.getCode(this, data).then(function(response) {
                    window.location = redirect_uri + '?code=' + response.data.authorizationCode;
                });
            },
            getIntroVideo() {
                var self = this;
                let week = this.currentWeek + 1;

                if (this.showXmasVideo === true) {
                    this.introVideoUrl = 'https://s3-us-west-2.amazonaws.com/ttto-intro-videos/fee9c950-1a19-406f-b09a-daeedbd6163c.mp4';
                    this.noIntroVideo = false;
                    return;
                }

                introVideos.get(this, this.$store.getters.currentTerm.id, week).then(function(response) {
                    if (response.data.videos && response.data.videos.length > 0) {
                        const url = response.data.videos[0].url;
                        self.introVideoUrl = url;
                        self.noIntroVideo = false;
                    } else {
                        if (localStorage.terms != '858356') {
                            self.noIntroVideo = true;
                        }                       
                    }

                }).catch(function(e) {
                    console.log(e);
                })
            },
            selectCourse(id) {
                if (id === this.selectedCourse) {
                    this.selectedCourse = null;
                } else {
                    this.selectedCourse = id;
                }
            },

            getCourses(week) {
                var self = this;
                week = week + 1;
                let termId = this.$store.getters.currentTerm.id;
                let termType = this.$store.getters.currentTerm.type;

                self.$store.dispatch('toggle',{type:'loading', boolean: true});
                courses.get(this, null, null, termId, termType, week).then(function(response) {
                    self.$store.dispatch('toggle',{type:'loading', boolean: false});
                    if (!response.data.courses) response.data.courses = [];
                    let courses = response.data.courses.map(function(c) { c.assignments = []; return c; });

                    submissions.getMine(this).then(function(r) {
                        var mySubmissions = r.data.submissions;
                        assignments.getAll(this).then(function(res) {
                            res.data.assignments.forEach(function(a) {
                                let index = courses.findIndex(function(c) {
                                    return parseInt(c.id) === a.instanceId || c.id == a.instanceId
                                });
                                let submissionsIndex = mySubmissions.findIndex(function(s) { return s.assignmentId == a.id});
                                if (submissionsIndex > -1) {
                                    a.submission = mySubmissions[submissionsIndex];
                                }

                                if (index > -1) {
                                    courses[index].assignments.push(a)
                                }
                            });


                            self.$store.dispatch('populate', {type: 'courses', data: courses});
                            self.assignmentsLoaded = true;
                        });
                    });
                });
            },
            calculateProgress(progressions, chapters) {
                if (!Array.isArray(progressions) || progressions.length === 0) {
                    return 0;
                }
                var totalDuration = chapters.map(function(c) { return c.duration}).reduce(function(a, b) { return a + b; });
                var totalProgress = progressions.map(function(p) { return Math.round(p.progress)}).reduce(function(a, b) { return a + b; });
                let percentage = Math.round((totalProgress/totalDuration)*100);
                if (percentage > 100) percentage = 100;
                return percentage;

            },
            assignmentThisWeek(assignments, week) {
                var self = this;
                assignments = assignments.filter(function(a) {
                    return a.week === week;
                });

                if (assignments && assignments.length > 0) return assignments[0];

                return false;

            },

            isNotInPast(endDate) {
                var endDate = new Date(endDate);
                var now = new Date();
                if (endDate > now)  {
                    return true;
                } else {
                    return false;
                }
            },
        },

        computed: {
            hasCourseSets() {
                return localStorage.has_course_sets === 'true';
            },
            weekChange() {
                this.currentWeek = this.$store.getters.currentWeek;
            },
            instances() {
                if (this.$store.getters.courses) {
                    return this.$store.getters.courses.map(function(c) {
                        return c.id
                    });
                }
            },
            news() {
                return this.$store.state.news.article;
            },
            courses() {
                return this.$store.getters.courses;
            },
            terms() {
                return this.$store.state.terms;
            },
            student() {
                return this.$store.state.student;
            },
            currentTerm() {
                return this.$store.getters.currentTerm;
            },

        }
    }
</script>

<style>
    path {
        shape-rendering: geometricPrecision;
    }

</style>


<style lang="scss">


    // .intro-video-wrapper {
        //     .video-player, video, .video-player .video-js {
            //         max-height:300px!important;
            //     }
        //     .video-js {
            //         position: relative !important;
            //     }
        // }

    .video-thumbnail {
        position:relative;
        a {
            height: 110px;
            display: block;
        }
        .play-button {
            position:absolute;
            top:0;
            left:0;
            right:0;
            bottom:0;
            margin:auto;
        }
        img.course-image {
            object-fit: cover;
            height: 110px;

            width: 168px!important;
            // height: 100%;
        }

    }
    .video-thumb-wrapper {
        padding:0px!important;
    }

    .course-details {
        padding:0 5px 10px 5px;
        .icon {
            margin-top:10px;
        }
    }



    .video-thumb-wrapper:not(.final-project):hover {
        box-shadow: 0px 0px 20px #33ccff;
    }

    .ttto-progress-wrapper {
        height:6px;
        background: #9d9d9d;
        width:100%;
        margin-top:2rem;
        margin-bottom: 10px;
    }
    .ttto-progress {
        top:0px;
        max-width: 100%;
        height:6px;
        background:#33ccff;
        box-shadow:0px 0px 10px 2px rgba(51,204,255,.5);
        position:relative;
        //background: -moz-linear-gradient(top, rgba(39,78,91,1) 0%, rgba(48,173,210,1) 25%, rgba(51,204,255,1) 50%, rgba(48,173,210,1) 75%, rgba(39,78,91,1) 100%); /* FF3.6-15 */
        //background: -webkit-linear-gradient(top, rgba(39,78,91,1) 0%,rgba(48,173,210,1) 25%,rgba(51,204,255,1) 50%,rgba(48,173,210,1) 75%,rgba(39,78,91,1) 100%); /* Chrome10-25,Safari5.1-6 */
        //background: linear-gradient(to bottom, rgba(39,78,91,1) 0%,rgba(48,173,210,1) 25%,rgba(51,204,255,1) 50%,rgba(48,173,210,1) 75%,rgba(39,78,91,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        //filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#274e5b', endColorstr='#274e5b',GradientType=0 );

        &::after {
            content:'';
            height:1.5rem;
            width:3px;
            background:#33ccff;
            display:block;
            position:absolute;
            right:-3px;
            top:-5px;
            box-shadow:0px 0px 10px 2px rgba(51,204,255,.5);
            //background: -moz-linear-gradient(left, rgba(39,78,91,1) 0%, rgba(48,173,210,1) 25%, rgba(51,204,255,1) 50%, rgba(48,173,210,1) 75%, rgba(39,78,91,1) 100%); /* FF3.6-15 */
            //background: -webkit-linear-gradient(left, rgba(39,78,91,1) 0%,rgba(48,173,210,1) 25%,rgba(51,204,255,1) 50%,rgba(48,173,210,1) 75%,rgba(39,78,91,1) 100%); /* Chrome10-25,Safari5.1-6 */
            //background: linear-gradient(to right, rgba(39,78,91,1) 0%,rgba(48,173,210,1) 25%,rgba(51,204,255,1) 50%,rgba(48,173,210,1) 75%,rgba(39,78,91,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
            //filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#274e5b', endColorstr='#274e5b',GradientType=1 );

        }
    }

</style>


<style lang="scss" scoped>
    .course-widget-wrapper, .panel-heading.assignments {
        h2 {
            display:inline-block!important;
            width:auto!important;
        }
    }
    .course-widget-wrapper {
        .panel-heading {
            white-space: nowrap;
        }
    }
    .course-set-switcher {
        display:inline-block;
        padding-left:0;
        ul {
            display:flex;
            text-align: center;
            padding:5px;
            align-items: center;
            justify-content: space-between;
            li {
                padding:0 1rem;

            }
            li:first-child {
                padding-left:2rem;
                padding-right:.5rem;
            }
            li:first-child span::after {
                content:'/';
                position: absolute;
                right:-1.1rem;
                color:#fff!important;
                top:0;
            }
        }
        span {
            position: relative;
            color: #fff;
            cursor: pointer;
        }
        span.selected {
            color: #3cf;
            text-decoration: underline;
        }
    }
    .no-video {
        color: darken(#b0b0b0,20%);
        &>div{
            padding-top:1rem;
            padding-bottom:1rem;
        }
        .col-xs-4 {
            background:#111;
        }
        a {
            color: darken(#b0b0b0,20%);
            font-size:1.4rem;
        }
    }
    .course-list {
        padding:0px;
        .video {
            border-bottom: 6px solid #444 !important;
        }
        .faded {
            opacity:.6;
        }
        .video:last-child {
            border-bottom: none !important;
        }
    }

    li.course-list {
        border-bottom: 6px solid #444 !important;
    }

    .timeline {
        margin-bottom: 20px;
    }
    .content {
        margin-top:1rem;
    }
    .byline {
        font-size:1.5rem;
        font-style:italic;
    }
    .points {
        display:block;
    }
    .courses {

        img {
            cursor:pointer;
        }
        h3 {
            font-size:1.8rem;
            line-height:initial;
            margin:1rem auto;
            float:left;
            cursor:pointer;
            color:#fff;
        }
        h3:hover {
            color:#33ccff;
        }
        .icon {
            float:right;
            margin-left:5px;
        }

        li {
            border:none;
            border-radius:0;
            border-bottom:6px solid #444!important;
        }
    }

    .download {
        margin-bottom: 2rem;
        padding-top:2rem;
    }
    .schedules {
        clear:both;
        li {
            cursor: pointer;
        }
    }

    .percent-watched {
        color:#33ccff;
    }

    .mock-assignments {
        width:100%;
    }

    .assignments {
        h2 img {
            margin-right:1rem;
        }
    }
</style>



// WEBPACK FOOTER //
// Home.vue?59dbdfea